import React from 'react';
import Button from './Button';

interface SpinnerButtonPropsBase {
  type: string;
  amount: number;
  buttonLabel?: string;
  singleMode?: boolean;
  block?: boolean;
  setAmount: (amount: number) => void;
}

export type SpinnerButtonProps = SpinnerButtonPropsBase & React.HTMLAttributes<HTMLDivElement>;

export default function SpinnerButton(props: SpinnerButtonProps) {
  const {
    amount,
    block,
    singleMode,
    setAmount,
    type,
    buttonLabel = 'Add',
    className: propClasses,
    ...rest
  } = props;

  const classes = [];
  if (propClasses) classes.push(propClasses);

  return (
    <div {...rest} className={classes.join(' ')}>
      {amount === 0 ? (
        <Button
          onClick={() => setAmount(1)}
          icon={['fass', 'plus']}
          variant="borderlike"
          block={block}
        >
          {buttonLabel}
        </Button>
      ) : singleMode ? (
        <Button
          onClick={() => setAmount(0)}
          icon={['fass', 'check']}
          variant="accent"
          block={block}
        >
          {buttonLabel}ed
        </Button>
      ) : (
        <div
          role="group"
          aria-label={`Adjust ${type} quantity`}
          className="flex items-center rounded-lg overflow-hidden bg-accent 
            focus-within:outline focus-within:outline-2 focus-within:outline-offset-2 
            focus-within:outline-accent"
        >
          <Button
            variant="accent"
            aria-label={amount === 1 ? `Remove ${type}` : `Decrease ${type} quantity`}
            onClick={() => setAmount(amount - 1)}
            icon={amount === 1 ? ['fass', 'trash'] : ['fass', 'minus']}
            className="focus:outline-none p-3-i no-disabled"
            block={block}
          />
          <div className="text-white w-8 text-center">{amount}</div>
          <Button
            variant="accent"
            aria-label={`Increase ${type} quantity`}
            onClick={() => setAmount(amount + 1)}
            icon={['fass', 'plus']}
            className="focus:outline-none p-3-i no-disabled"
            block={block}
          />
        </div>
      )}
    </div>
  );
}
